import { WithNoProgress } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/ProgressBarAndTimeline/_shared/WithNoProgress';
import { WithProgress } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/ProgressBarAndTimeline/Progress/WithProgress/WithProgress';
import { PaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/PaymentMethodDetail/PaymentMethodDetailEntity';

interface ProgressBarAndTimelineProps {
  paymentMethodDetailEntity: PaymentMethodDetailEntity;
}

export const ProgressBarAndTimeline = ({ paymentMethodDetailEntity }: ProgressBarAndTimelineProps) => {
  if (paymentMethodDetailEntity.paymentMethodId) {
    return <WithProgress paymentMethodDetailEntity={paymentMethodDetailEntity} />;
  }

  return <WithNoProgress paymentMethodDetailEntity={paymentMethodDetailEntity} />;
};
